import { isNil } from 'lodash';

const reducePinFailure = (state, data) => ({
  ...state,
  lockToken: null,
  lockError: isNil(data) || data === '' ? true : String(data),
});

// noinspection JSUnusedGlobalSymbols
export default reducePinFailure;
